import { Component, OnInit } from "@angular/core";
import { ApiResponse } from "../../models/api-response";
import { PermissionDetails } from "./permission-details";
import { AccessManagementService } from "./access-management.service"
import { AppSettingsService } from "../../services/appsettings.service"
import { NotificationService } from "../../services/notification.service";
import { Observable } from "rxjs/Observable";

@Component({
    selector: "access-management",
    template: require("./access-management.component.html")
})
export class AccessManagementComponent {

    guidValidatorRegex = new RegExp("^[{(]?[0-9A-Fa-f]{8}[-]?([0-9A-Fa-f]{4}[-]?){3}[0-9A-Fa-f]{12}[)}]?$");
    currentEntity = "Application";
    permissionTypes = ["Global", "System", "Tenant", "Model", "SystemType","ModelType", "SystemService", "DeviceType"];
    labelForpermissionType: Map<string, string>;
    validatorsForpermissionTypeValue: Map<string, any>;
    labelForPermissionTypeValue: string;
    selectedPermissionType: string;
    permissionsRetrieved = false;
    permissions: Array<PermissionDetails>;
    globalItemPermissions: Array<PermissionDetails>;
    valueForpermissionType: string;
    entityId: string;
    errorMessage: string;
    isErrorResponse = false;
    permissionRequiresUserInput = false;
    isFetching: boolean;
    infoMessage: string;
    isSuccess: boolean;
    successMessage: string;
    isForgeRockEnabled: boolean = false;
    projectName: string;
    tagName: string;
    activityName: string;
    globalActivities = ["Activity1", "Activity2" ,"Activity3"];
    globalActivity: string;
    private currentTab: boolean;
    
    
    constructor(private accessService: AccessManagementService,
        private appSettingsService: AppSettingsService,
        private notifier: NotificationService) {
        this.notifier.clear();
        this.selectedPermissionType = this.permissionTypes[0];
        if (this.selectedPermissionType === "Global") {
            this.configureGlobalSettings();
        }
        this.isForgeRockEnabled = appSettingsService.forgeRockEnabled;
        if (this.isForgeRockEnabled) {
            this.permissionTypes.push("ForgeRock");
        }
        this.addValidators();
        this.populateLabelNames();
        this.labelForPermissionTypeValue = this.labelForpermissionType[this.selectedPermissionType];
    }

    setCurrentEntity(entity: string) {
        this.notifier.clear();
        this.permissionsRetrieved = false;
        this.currentEntity = entity;
        this.entityId = "";
    }

    setCurrentPermissionType(permissionType: string) {
        this.notifier.clear();
        this.permissionsRetrieved = false;
        this.selectedPermissionType = permissionType;
        this.valueForpermissionType = "";
        this.labelForPermissionTypeValue = this.labelForpermissionType[this.selectedPermissionType];
        this.currentTab = false;
        if (permissionType === "Global" || permissionType === "ForgeRock") {
            this.configureGlobalSettings();
        } else if(permissionType === "ProjectGlobal"){
            this.currentTab = true;
            this.getGlobalPermissionList();
        } else if(permissionType === "ProjectTag"){
            
        }
         else {
            this.permissionRequiresUserInput = true;
        }
        
    }

    getPermissionList() {
        if (this.areEntriesInvalid()) return;
       
        this.notifier.displayInfo("Fetching permissions...");
        if (this.selectedPermissionType === "ForgeRock") {
            this.accessService.getForgeRockPermissionDetails(
                    this.currentEntity,
                    this.entityId,
                    "global",
                    this.valueForpermissionType)
                .subscribe(
                    response => {
                        this.notifier.clear();
                        this.permissions = (response as ApiResponse).data.permissions as Array<PermissionDetails>;
                        this.permissionsRetrieved = true;
                        this.globalActivity = this.permissions[0].activity
                    },
                    error => {
                        this.notifier.displayApiResponseError(error);
                        this.permissionsRetrieved = false;
                    }
                );
        } else {
            this.accessService.getPermissionDetails(
                    this.currentEntity,
                    this.entityId,
                    this.selectedPermissionType,
                    this.valueForpermissionType)
                .subscribe(
                    response => {
                        this.notifier.clear();
                        this.permissions = (response as ApiResponse).data.permissions as Array<PermissionDetails>;
                        this.permissionsRetrieved = true;
                    },
                    error => {
                        this.notifier.displayApiResponseError(error);
                        this.permissionsRetrieved = false;
                    }
                );
        }

    }

    savePermissions() {

        if (this.areEntriesInvalid()) return;

        this.notifier.displayInfo("Saving permissions");
        if (this.selectedPermissionType === "ForgeRock") {
            this.accessService.saveForgeRockPermissionDetails(
                    this.currentEntity,
                    this.entityId,
                    "global",
                    this.valueForpermissionType,
                    this.permissions)
                .subscribe(
                    response => {
                        this.notifier.displaySuccess("Successfully updated permissions");
                    },
                    error => {
                        this.notifier.displayApiResponseError(error);
                    }
                );
        } else {
            this.accessService.savePermissionDetails(
                    this.currentEntity,
                    this.entityId,
                    this.selectedPermissionType,
                    this.valueForpermissionType,
                    this.permissions)
                .subscribe(
                    response => {
                        this.notifier.displaySuccess("Successfully updated permissions");
                    },
                    error => {
                        this.notifier.displayApiResponseError(error);
                    }
                );
        }
    }

    configureGlobalSettings() {
        this.permissionRequiresUserInput = false;
        this.appSettingsService.getGlobalName()
            .subscribe(
            response => {
                    this.notifier.clear();
                    this.valueForpermissionType = response._body;
                    this.permissionRequiresUserInput = false;

                },
            error => {
                    this.notifier.displayError("Failed to fetch global name");
                }
            );
    }

    validateStringValues(value: string, label: string) {
        if (value == null || value.trim() === "") {
            this.notifier.displayError(`Enter a valid ${label}`);
            return false;
        } else {
            this.isErrorResponse = false;
            return true;
        }
    }

    validateGuidValues(value: string, label: string): boolean {
        if (!this.guidValidatorRegex.test(value)) {
            this.notifier.displayError(`Enter a Guid for ${label}`);
            return false;
        }
        this.isErrorResponse = false;
        return true;
    }

    areEntriesInvalid(): boolean {
        if (this.validateGuidValues(this.entityId, this.currentEntity) === false) return true;
        if (this.validatorsForpermissionTypeValue[this.selectedPermissionType]  === false) return true;
        return false;
    }

    addValidators() {
        this.validatorsForpermissionTypeValue = new Map<string, any>();
        this.validatorsForpermissionTypeValue[this.permissionTypes[0]] = () => this
            .validateStringValues(this.valueForpermissionType, this.labelForpermissionType[0]);
        this.validatorsForpermissionTypeValue[this.permissionTypes[1]] = () => this
            .validateGuidValues(this.valueForpermissionType, this.labelForpermissionType[1]);
        this.validatorsForpermissionTypeValue[this.permissionTypes[2]] = () => this
            .validateStringValues(this.valueForpermissionType, this.labelForpermissionType[2]);
        this.validatorsForpermissionTypeValue[this.permissionTypes[3]] = () => this
            .validateGuidValues(this.valueForpermissionType, this.labelForpermissionType[3]);
        this.validatorsForpermissionTypeValue[this.permissionTypes[4]] = () => this
            .validateStringValues(this.valueForpermissionType, this.labelForpermissionType[4]);
        this.validatorsForpermissionTypeValue[this.permissionTypes[5]] = () => this
            .validateStringValues(this.valueForpermissionType, this.labelForpermissionType[5]);
        this.validatorsForpermissionTypeValue[this.permissionTypes[6]] = () => this
            .validateStringValues(this.valueForpermissionType, this.labelForpermissionType[6]);
        this.validatorsForpermissionTypeValue[this.permissionTypes[7]] = () => this
            .validateStringValues(this.valueForpermissionType, this.labelForpermissionType[7]);
        if (this.isForgeRockEnabled) {
            this.validatorsForpermissionTypeValue[this.permissionTypes[8]] = () => this
                .validateStringValues(this.valueForpermissionType, this.labelForpermissionType[8]);
        }
    }

    populateLabelNames() {
        this.labelForpermissionType = new Map<string, string>();
        this.labelForpermissionType[this.permissionTypes[0]] = "Global name";
        this.labelForpermissionType[this.permissionTypes[1]] = "System Guid";
        this.labelForpermissionType[this.permissionTypes[2]] = "Tenant name";
        this.labelForpermissionType[this.permissionTypes[3]] = "Model Id";
        this.labelForpermissionType[this.permissionTypes[4]] = "System type";
        this.labelForpermissionType[this.permissionTypes[5]] = "Model Type Id";
        this.labelForpermissionType[this.permissionTypes[6]] = "System service";   
        this.labelForpermissionType[this.permissionTypes[7]] = "Device type name";
        if (this.isForgeRockEnabled) {
            this.labelForpermissionType[this.permissionTypes[8]] = "ForgeRock";
        }
        
    }

    areEntityEntriesInvalid(): boolean {
        if (this.validateGuidValues(this.entityId, this.currentEntity) === false) return true;
        return false;
    }

    addTagPermission() {
        if (this.validateGuidValues(this.entityId, this.currentEntity) === false) return true;
        this.permissions = [];
        this.permissions.push(new PermissionDetails(this.activityName, this.activityName, true));
        var finalName = "";
        if(this.projectName === '/'){
            finalName = this.tagName;
        } else {
            finalName = this.projectName +"/"+this.tagName;
        }
        console.log(this.permissions);
        this.notifier.displayInfo("Saving permissions");
            this.accessService.addTagPermission(
                    this.currentEntity,
                    this.entityId,
                    btoa(finalName),
                    this.permissions)
                .subscribe(
                    response => {
                        this.notifier.displaySuccess("Successfully updated permissions");
                    },
                    error => {
                        this.notifier.displayApiResponseError(error);
                    }
                );
    }
    checkTagPermission(){
        if (this.validateGuidValues(this.entityId, this.currentEntity) === false) return true;
        var finalName = "";
        if(this.projectName === '/'){
            finalName = this.tagName;
        } else {
            finalName = this.projectName +"/"+this.tagName;
        }
        this.notifier.displayInfo("Checking permissions");
            this.accessService.checkTagPermission(
                    this.currentEntity,
                    this.entityId,
                    btoa(finalName),
                this.activityName)
                .subscribe(
                    response => {
                        if(response.data.checkTagPermissionsResponseDTO.isAuthorized == true)
                        this.notifier.displaySuccess("Entity is authorised");
                        else
                        this.notifier.displaySuccess("Entity is unauthorised");
                    },
                    error => {
                        this.notifier.displayApiResponseError(error);
                    }
                );
    }
    deleteTagPermission(){
        if (this.validateGuidValues(this.entityId, this.currentEntity) === false) return true;
        this.permissions = [];
        this.permissions.push(new PermissionDetails(this.activityName, this.activityName, true));
        var finalName = "";
        if(this.projectName === '/'){
            finalName = this.tagName;
        } else {
            finalName = this.projectName +"/"+this.tagName;
        }
        console.log(this.permissions);
        this.notifier.displayInfo("Deleting permissions");
            this.accessService.deleteTagPermission(
                    this.currentEntity,
                    this.entityId,
                    btoa(finalName),
                    this.permissions)
                .subscribe(
                    response => {
                        this.notifier.displaySuccess("Successfully deleted permissions");
                    },
                    error => {
                        this.notifier.displayApiResponseError(error);
                    }
                );
    }

    addGlobalPermission() {
        if (this.validateGuidValues(this.entityId, this.currentEntity) === false) return true;
        this.globalItemPermissions = [];
        this.globalItemPermissions.push(new PermissionDetails(this.globalActivity, this.globalActivity, true));
        this.notifier.displayInfo("Saving permissions");
            this.accessService.addGlobalPermission(
                    this.currentEntity,
                    this.entityId,
                    btoa(this.projectName),
                    this.globalItemPermissions)
                .subscribe(
                    response => {
                        this.notifier.displaySuccess("Successfully updated permissions");
                    },
                    error => {
                        this.notifier.displayApiResponseError(error);
                    }
                );
    }
    checkGlobalPermission(){
        if (this.validateGuidValues(this.entityId, this.currentEntity) === false) return true;
        this.notifier.displayInfo("Checking permissions");
        this.accessService.checkGlobalPermission(
                this.currentEntity,
                this.entityId,
                btoa(this.projectName),
                this.globalActivity)
            .subscribe(
                response => {
                    console.log(response);
                    if(response.data === true)
                    this.notifier.displaySuccess("Entity is Authorised");
                    else
                    this.notifier.displaySuccess("Entity is Unauthorised");
                },
                error => {
                    this.notifier.displayApiResponseError(error);
                }
            );
    }
    deleteGlobalPermission(){
        if (this.validateGuidValues(this.entityId, this.currentEntity) === false) return true;
        this.globalItemPermissions = [];
        this.globalItemPermissions.push(new PermissionDetails(this.globalActivity, this.globalActivity, true));
        this.notifier.displayInfo("Deleting permissions");
            this.accessService.deleteGlobalPermission(
                    this.currentEntity,
                    this.entityId,
                    btoa(this.projectName),
                    this.globalItemPermissions)
                .subscribe(
                    response => {
                        this.notifier.displaySuccess("Successfully deleted permissions");
                    },
                    error => {
                        this.notifier.displayApiResponseError(error);
                    }
                );
    }

    configureGlobalSettingsWithCallback(callback: () => void) {
        this.permissionRequiresUserInput = false;
        this.appSettingsService.getGlobalName()
            .subscribe(
            response => {
                    this.notifier.clear();
                    this.valueForpermissionType = response._body;
                    this.permissionRequiresUserInput = false;
                    callback();
                },
            error => {
                    this.notifier.displayError("Failed to fetch global name");
                }
            );
    }

    getGlobalPermissionList(){
        if (this.validateGuidValues(this.entityId, this.currentEntity) === false && this.currentTab === false) return true;
        this.selectedPermissionType = "Global";

        this.configureGlobalSettingsWithCallback(() => {
            this.getPermissionList();
        });


        // this.configureGlobalSettings();
        // this.getPermissionList();
    }
}


/** WEBPACK FOOTER **
 ** ./F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/app/main/accessManagement/access-management.component.ts
 **/